<div class="hidden md:flex items-center">
  @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
    <div>
      @if (!last) {
        <a (click)="action.emit(breadcrumb)" class="text-primary cursor-pointer">
          {{ breadcrumb.label }}
        </a>
      }
      @if (last) {
        <span>
          {{ breadcrumb.label }}
        </span>
      }
      @if (!last) {
        <fa-icon [icon]="dividerIcon" class="mx-2"></fa-icon>
      }
    </div>
  }
</div>

@if (breadcrumbs.length > 0) {
  <div [title]="breadcrumbs[breadcrumbs.length - 1].label" class="flex md:hidden">
    {{ breadcrumbs[breadcrumbs.length - 1].label | truncate : 25 }}
  </div>
}
